import React from 'react';

import { Layout } from '../../components/Layout/Layout';
import { Section } from '../../components/Section/Section';
import { StatusMessage } from '../../components/StatusMessage/StatusMessage';
import { typedMemo } from '../../utils/typedMemo';
import { InfoContent } from './InfoContent';
import * as types from './types';

export const InfoSection = typedMemo(
  <T extends types.InfoType>({
    description,
    infos = [],
    title,
    toggle,
  }: types.InfoSection<T>) => {
    return (
      <Section
        key={title}
        description={description}
        title={title}
        toggle={toggle}
      >
        <Layout preset="subsections">
          {infos.map((info) => (
            <React.Fragment key={info.title}>
              <Section
                description={info.description}
                heading="h4"
                title={info.title}
                toggle={info.toggle}
              >
                <InfoContent {...info} />
              </Section>
              {info.statusMessage && <StatusMessage {...info.statusMessage} />}
            </React.Fragment>
          ))}
        </Layout>
      </Section>
    );
  },
);
